export default "__VITE_ASSET__CsZwgB6q__"